import { SingleRadio } from "components/Atoms/inputs/RadioGroup";
import { InPageEditableStandaloneField } from "components/MainSectionTemplate/InPageEditableStandaloneField";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import React from "react";

interface Props {
  option: string
  defaultOption: string | null
  onChangeLabel: (newOption: string) => void
  onSetAsDefault: () => void
}

export const DropdownRow = (props: Props) => {
  return <div className="flex gap grow1">
    <SingleRadio
      value={props.option}
      selected={props.defaultOption}
      onChange={() => props.onSetAsDefault()}
    />
    <div className="grow1">
      <InPageEditableStandaloneField
        value={props.option || ""}
        onValueUpdated={newVal => {
          props.onChangeLabel(newVal.trim());
        }}
        render={() => <span>
          {props.option}
        </span>}
        renderEdit={({ value, onChange, submit, cancel }) => <OptionalTextInput
          focusOnMount
          value={value}
          maxLength={serverReference.constants.excelTemplate.maxMergeFieldIdLength}
          onChange={onChange}
          onEnter={submit}
          onEsc={cancel}
        />}
      />
    </div>
  </div>
}

interface NoChoiceMadeDropdownRowProps {
  defaultOption: string | null
  onSetAsDefault: () => void
}

export const NoChoiceMadeDropdownRow = (props: NoChoiceMadeDropdownRowProps) => {
  return <div className="no-choice-made-dropdown-row flex">
    <div className="flex gap grow1">
      <SingleRadio
        value={null}
        selected={props.defaultOption}
        onChange={() => props.onSetAsDefault()}
      />
      <span>{RESX.GeneralLabels.NoChoiceMade}</span>
    </div>
  </div>
}